import { createActions, handleActions } from 'redux-actions'

export const actionCreators = createActions({
    TIMELINE: {
        YEAR: (params) => params,
        MONTH: (params) => params,
        DAY: (params) => params,
        CATEGORY: (params) => params,
        SHOW: (params) => params,
        HIDE: (params) => params,
        CO2: (params) => params,
        SHIPTYPE: (params) => params,
    }
});

const reducer = handleActions({
    TIMELINE: {
        CO2: (state, action) => {
            const { currentCO2 } = action.payload
            return { ...state, currentCO2 }
        },
        SHIPTYPE: (state, action) => {
            const {shipType} = action.payload
            return {...state, shipType }
        },
        YEAR: (state, action) => {
            const { year } = action.payload
            return { ...state, currentYear: year }
        },
        MONTH: (state, action) => {
            const { month } = action.payload
            return { ...state, currentMonth: month }
        },
        DAY: (state, action) => {
            const { day } = action.payload
            return { ...state, currentDay: day }
        },
        CATEGORY: (state, action) => {
            const { category } = action.payload
            return { ...state, category, currentYear: undefined, currentMonth: undefined, currentDay: undefined }
        },
        SHOW: (state, action) => {
            const { currentLayerGroup } = action.payload
            return { ...state, visible: true, currentLayerGroup, currentYear: undefined, currentMonth: undefined, currentDay: undefined }
        },
        HIDE: (state, action) => {
            return { ...state, visible: false, currentYear: undefined, currentMonth: undefined, currentDay: undefined }
        }
    }
}, {
    dateRanges: {

    },
    category: 'history',
    currentYear: undefined,
    currentMonth: undefined,
    currentDay: undefined,
    currentCO2: '4_5',
    shipType: 'NO_ICE',
    currentLayerGroup: 'concentration',
});

export default reducer